import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Gift, Moon, ArrowRight } from "@phosphor-icons/react";
import { SPECIAL_SLOGAN } from "../data";

export const SpecialTeaser = () => {
  const navigate = useNavigate();
  return (
    <section data-testid="special-teaser" className="py-16 sm:py-24 bg-brandred text-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1.2fr_0.8fr] gap-10 items-center">
        <div>
          <span className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/30 text-xs font-bold uppercase tracking-[0.2em] px-3 py-1.5 mb-5">
            <Moon weight="fill" size={14} /> New · Midnight delivery
          </span>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
            {SPECIAL_SLOGAN}
          </h2>
          <p className="mt-5 max-w-xl text-white/90 text-base sm:text-lg leading-relaxed">
            Gifts, birthday cakes, flowers and food for those special moments — book us and
            we'll be there right at midnight to knock on your door.
          </p>
          <motion.button
            whileHover={{ x: 4 }}
            data-testid="special-teaser-cta"
            onClick={() => { navigate("/special-arrangements"); window.scrollTo({ top: 0 }); }}
            className="mt-8 inline-flex items-center gap-2.5 bg-ink text-white font-bold text-base px-7 py-4 border-2 border-ink shadow-[6px_6px_0_0_#FFDE00] hover:shadow-none hover:translate-x-[3px] hover:translate-y-[3px] transition-all duration-150"
          >
            Explore special arrangements <ArrowRight weight="bold" size={18} />
          </motion.button>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.9, rotate: -3 }}
          whileInView={{ opacity: 1, scale: 1, rotate: -3 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="hidden lg:flex justify-center"
        >
          <div className="w-56 h-56 bg-sun text-ink border-2 border-ink flex flex-col items-center justify-center shadow-[10px_10px_0_0_#0A0A0A]">
            <Gift weight="fill" size={72} />
            <p className="font-display font-extrabold text-3xl mt-2">12:00</p>
            <p className="text-xs font-bold uppercase tracking-[0.2em]">At your door</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
